import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
    return (
        <footer className="bg-[#0A2540] text-white" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-1">
                    <div className="brand-wordmark text-2xl tracking-tight">
                        <span className="text-[#C5A059]">EZ</span> Permit Express
                    </div>
                    <p className="mt-4 text-sm leading-relaxed text-white/70">
                        Nationwide permit processing and architectural services. Fast, reliable, and stress-free from start to approval.
                    </p>
                </div>

                <div>
                    <h4 className="text-sm uppercase tracking-[0.2em] text-[#C5A059] font-semibold">
                        Services
                    </h4>
                    <ul className="mt-4 space-y-2 text-sm text-white/80">
                        <li><Link to="/services" className="hover:text-[#C5A059] transition-colors">Permit Processing</Link></li>
                        <li><Link to="/services" className="hover:text-[#C5A059] transition-colors">Architectural Plans</Link></li>
                        <li><Link to="/services" className="hover:text-[#C5A059] transition-colors">Engineering Coordination</Link></li>
                        <li><Link to="/services" className="hover:text-[#C5A059] transition-colors">ADU & Residential</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-sm uppercase tracking-[0.2em] text-[#C5A059] font-semibold">
                        Company
                    </h4>
                    <ul className="mt-4 space-y-2 text-sm text-white/80">
                        <li><Link to="/about" className="hover:text-[#C5A059] transition-colors">About Us</Link></li>
                        <li><Link to="/how-it-works" className="hover:text-[#C5A059] transition-colors">How It Works</Link></li>
                        <li><Link to="/contact" className="hover:text-[#C5A059] transition-colors">Contact</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-sm uppercase tracking-[0.2em] text-[#C5A059] font-semibold">
                        Contact
                    </h4>
                    <ul className="mt-4 space-y-3 text-sm text-white/80">
                        <li className="flex items-start gap-3">
                            <Phone size={16} className="mt-0.5 text-[#C5A059]" />
                            <a href="tel:9512493125" className="hover:text-[#C5A059]" data-testid="footer-phone">951-249-3125</a>
                        </li>
                        <li className="flex items-start gap-3">
                            <Mail size={16} className="mt-0.5 text-[#C5A059]" />
                            <a href="mailto:info@ezpermitexpress.com" className="hover:text-[#C5A059]" data-testid="footer-email">
                                info@ezpermitexpress.com
                            </a>
                        </li>
                        <li className="flex items-start gap-3">
                            <MapPin size={16} className="mt-0.5 text-[#C5A059]" />
                            Nationwide Service
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-white/60">
                    <p>© {new Date().getFullYear()} EZ Permit Express. All rights reserved.</p>
                    <p>Licensed architectural & permit expediting services.</p>
                </div>
            </div>
        </footer>
    );
}
